<template>
    <dialogs-base :show.sync="dialog" :max-width="maxWidth">
        <template v-slot:body>
            <v-card color="primary" dark>
                <v-card-text>
                    {{ label }}
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
      </v-card>
        </template>
    </dialogs-base>
</template>

<script setup>
import { defineProps, ref, watch } from 'vue';

const props = defineProps({
    show: { type: Boolean, default: false },
    maxWidth: { type: String, default: "20%" },
    label: { type: String, default: 'Aguarde...'}
})

const dialog = ref(props.show)

watch(() => props.show, (val) => {
    dialog.value = val
})

</script>